// extracted by mini-css-extract-plugin
export default {"placeholder":"pVShTBoU","mobile":"mobile","content":"HgyCNAZb","emoji":"DjIJTkol"};